import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from '@/modules/draw/draws/store/drawSlice/initialState.ts'

const drawSlice = createSlice({
  name: 'draw',
  initialState,
  reducers: {
    setIsCreateModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isCreateModalOpen = action.payload
    },
    setEditId: (state, action: PayloadAction<number | null>) => {
      state.editId = action.payload
    },
    setFilters: (state, action: PayloadAction<string>) => {
      state.filters = action.payload
    },
    reset: () => initialState
  }
})

export const drawActions = drawSlice.actions
export const { reducer: drawReducer } = drawSlice
